import { ReactComponent as AppStoreIcon } from '../assets/appstore.svg';
import { ReactComponent as GooglePlayIcon } from '../assets/googleplay.svg';
import styles from '../styles/moreGamesModal.module.scss';

function Content(props: {
  icon: string,
  info: string,
  mobileLink: {
    ios: {
      qr: string,
      link: string
    },
    android: {
      qr: string,
      link: string
    }
  }
}) {
  return (
    <div className={styles.content}>
      <main className={styles.main}>
        <aside>
          <div className={styles.icon}>
            <img src={props.icon} alt='game icon'/>
          </div>
        </aside>
        <div className={styles.info}>
          {props.info}
        </div>
      </main>
      <footer>
        <img src={props.mobileLink.ios.qr} alt='ios link'/>
        <a href={props.mobileLink.ios.link} rel="noopener noreferrer" target="_blank"><AppStoreIcon /></a>
        <a href={props.mobileLink.android.link} rel="noopener noreferrer" target="_blank"><GooglePlayIcon /></a>
        <img src={props.mobileLink.android.qr} alt='android link'/>
      </footer>
    </div>
  );
}

export default Content;
